/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ContratClasseInfosDto
 */
export interface ContratClasseInfosDto {
    /**
     * 
     * @type {number}
     * @memberof ContratClasseInfosDto
     */
    idclasse?: number;
    /**
     * 
     * @type {string}
     * @memberof ContratClasseInfosDto
     */
    centre?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ContratClasseInfosDto
     */
    statutInscription?: string | null;
}

/**
 * Check if a given object implements the ContratClasseInfosDto interface.
 */
export function instanceOfContratClasseInfosDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ContratClasseInfosDtoFromJSON(json: any): ContratClasseInfosDto {
    return ContratClasseInfosDtoFromJSONTyped(json, false);
}

export function ContratClasseInfosDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContratClasseInfosDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idclasse': !exists(json, 'idclasse') ? undefined : json['idclasse'],
        'centre': !exists(json, 'centre') ? undefined : json['centre'],
        'statutInscription': !exists(json, 'statutInscription') ? undefined : json['statutInscription'],
    };
}

export function ContratClasseInfosDtoToJSON(value?: ContratClasseInfosDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idclasse': value.idclasse,
        'centre': value.centre,
        'statutInscription': value.statutInscription,
    };
}

